import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

interface ParamTypes{
  applicationID:number | string;
  permit:number | string;
  isDraft?: boolean;
}

export const getApplicationDetails = async ({applicationID, permit, isDraft}: ParamTypes) => {
  const url = isDraft 
  ? `/applications/${permit}/get_all?ApplicationID=${applicationID}&Filter=Draft` 
  : `/applications/${permit}/get_all?ApplicationID=${applicationID}`
    const response = await httpRequest(
      'GET',
      url
    );
    if (response?.status === 'success') {
      return response;
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
    }
  };